import { render } from "./category-tagetory.vue?vue&type=template&id=1b5110fb&scoped=true"
import script from "./category-tagetory.vue?vue&type=script&lang=js"
export * from "./category-tagetory.vue?vue&type=script&lang=js"

import "./category-tagetory.vue?vue&type=style&index=0&id=1b5110fb&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5110fb"]])

export default __exports__